var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.162,
    height: 26.162
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sun_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h26.162v26.165H0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sun_svg__a)",
    "data-name": "Group 662"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#43321e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.313 9.511a7.64 7.64 0 0 0-.32 6.455 7.65 7.65 0 0 0 9.973 4.2 7.65 7.65 0 0 0 4.2-9.973 7.65 7.65 0 0 0-9.973-4.2 7 7 0 0 0-.445.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#43321e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.945 16.419a5.1 5.1 0 0 0 .864-5.263M22.072 9.421l3.579-1.457M.511 18.198l3.579-1.457M22.026 16.851l3.561 1.5M.574 7.811l3.561 1.5M16.741 22.072l1.457 3.579M7.964.511 9.421 4.09M9.311 22.026l-1.5 3.561M18.351.574l-1.5 3.561M22.788 13.166h1.791M1.583 12.996h1.791M19.894 19.996l1.257 1.276M5.011 4.891l1.257 1.276M13.081 22.788l-.007 1.791M13.088 3.478V1.585M6.165 19.894l-1.276 1.257M21.272 5.011l-1.276 1.257M7.823 7.519"
  }))));
};
export default SvgSun;